import { getEnv } from 'ecx.saigon.ui.common';
import axios from 'axios';
import Vue from 'vue';

export default async function () {
  try {
    const env = await getEnv();
    const token = Vue.prototype.$auth.idTokenClaims.__raw;

    const response = await axios({
      method: 'GET',
      url: `${env.VUE_APP_LEGACY_HTTP}/leases`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data ? response.data.data.length > 0 : false;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
    return false;
  }
}
